import { FormView } from '../account/form-view';
import firebase from "firebase/app"
import "firebase/auth";

export default FormView.extend({

    executeOperation: function() {
        return new Promise((resolve, reject) => {

            const emailAddress = this.el.querySelector('#email').value;
            firebase.auth()
                .sendPasswordResetEmail(emailAddress)
                .then(() => { resolve(); })
                .catch((error) => {
                    switch(error.code) {
                        case "auth/invalid-email":
                            reject(getI18N(jlocale.emailErrornotvalid)); break;
                        case "auth/user-not-found":
                            reject(getI18N(jlocale.userNotFound)); break;
                        default:
                            reject(getI18N(jlocale.error)); break;
                    }
                });

        });
    }

});
